import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-upgrade-guide',
  templateUrl: './upgrade-guide.component.html',
  styleUrls: ['./upgrade-guide.component.scss'],
})
export class UpgradeGuideComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  public steps: number[] = [1,2,3]

  public async close(){
    await this.modalCtrl.dismiss()
  }

}
